import React from 'react'
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import { useDarkModeStore } from '../store/useDarkModeStore';
import { useLanguageStore } from '../store/useLanguageStore';
import { darkModeBackgroud, PAGESIZE } from '../utils/constants';

interface PaginationProps {
    page: number;
    pageSize: number;
    arrayLength: number;
    setPage: React.Dispatch<React.SetStateAction<number>>;
    setPageSize: React.Dispatch<React.SetStateAction<number>>;
}

export const Pagination: React.FC<PaginationProps> = ({ arrayLength, page, pageSize, setPage, setPageSize }) => {

    const { language } = useLanguageStore();
    const { darkMode } = useDarkModeStore();

    const pageSizes = [PAGESIZE, pageSize, 5, 10];
    const uniqueSortedPageSizes = [...new Set(pageSizes)].sort((a, b) => a - b);

    const handlePrevious = () => {
        if (page > 1) setPage(page - 1);
        else setPage(1);
    }

    const handleNext = () => {
        // if (!(arrayLength < pageSize)) setPage(page + 1);
        setPage(page + 1);
    }

    const handlePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = parseInt(e.target.value);
        setPage(1);
        setPageSize(value);
    }

    return (
        <div className='position-absolute d-flex align-items-center' style={{ right: 20, bottom: 5, zIndex: 12 }}>
            <div className={`me-3 d-flex align-items-center gap-2 ${darkMode && 'text-white'}`}>{language['RowsPerPage']}:
                <select
                    className='form form-select'
                    style={{ width: 'fit-content', background: darkMode ? darkModeBackgroud : 'white', color: darkMode ? 'white' : 'black' }}
                    value={pageSize}
                    onChange={handlePageSize}
                >
                    {uniqueSortedPageSizes?.map(item => <option key={item} value={item}>{item}</option>)}
                </select>
            </div>
            <span
                className={`me-3 ${darkMode && 'text-white'}`}
            >
                {language['Page']}: {page}
            </span>
            <span
                className={darkMode ? 'text-white' : ''}
                role='button'
                onClick={handlePrevious}
            >
                <NavigateBeforeRoundedIcon sx={{ width: 22, height: 22, opacity: page > 1 ? 1 : .5 }} />
            </span>
            <span
                className={darkMode ? 'text-white' : ''}
                role='button'
                onClick={handleNext}
            >
                <NavigateNextRoundedIcon sx={{ width: 22, height: 22, opacity: !(arrayLength < pageSize) ? 1 : .5 }} />
            </span>
        </div>
    );
}
export default Pagination